import { IonSegmentButton, IonSegment, IonSpinner, IonNote, IonActionSheet, IonRippleEffect, IonModal, IonList, IonPopover, useIonRouter, useIonViewWillLeave, IonFooter, IonChip, useIonViewDidEnter, IonInfiniteScrollContent, IonInfiniteScroll, IonText, IonThumbnail, IonBadge, IonImg, IonTextarea, IonProgressBar, IonAlert, IonGrid, IonRow, IonCol, IonCardTitle, IonCardSubtitle, IonCardHeader, IonCardContent, IonAvatar, IonToast, useIonViewWillEnter, IonIcon, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useRef, Component, useState, useEffect }  from 'react';
import { RouteComponentProps } from "react-router-dom";
import { person, checkmark, playSkipForward, arrowBackOutline, chatboxEllipsesOutline, trashBinOutline, lockOpenOutline, lockClosedOutline, createOutline, copyOutline, close, arrowRedoOutline, peopleOutline, imagesOutline, banOutline, trashOutline, listOutline, ellipsisVertical, walletOutline, imageOutline, closeOutline, personAdd, addOutline, sendOutline } from "ionicons/icons";
import { Keyboard } from '@capacitor/keyboard';
import { Camera, CameraResultType } from '@capacitor/camera';
import { Clipboard } from '@capacitor/clipboard';
import { Virtuoso, VirtuosoHandle } from 'react-virtuoso';

import './Main.css';
import './ChatMsg.css';

import { showTab, hideTab } from "../components/Tabs";
import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { handleRouteError } from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert, showConfirm } from '../components/Alert';

import { MsgData, MsgDataGroup, MsgUser } from "../data/message";
import ChatMsgGroup from "../components/ChatMsgGroup";
import GifContent, { LoadGifs, GifData } from "../components/GifContent";
import LikeErrComp from "../components/LikeErrComp";
import { ReadyAds, ShowAds } from "../components/Admob";

const total = 30;
var maxIndex = -1;
var minIndex = Number.MAX_VALUE;
var rawMsgList : MsgData[] = [];
var refreshTimer : any;
var chat_type : string = "";
var block_user : number = -1;
var block_type : string = "";
var scroll_y = 0;
var state : string = "";
var tickTimer : any;
var timer : number;
var total_time : number;
var thread_id : number = -1;
var typed_msg : string = "";

const RandomChat : React.FC = () => {

    const router = useIonRouter();
    
    const [userAvatar, setUserAvatar] = useState("https://nwallet.me/img/avt.jpg");
    const [otherAvatar, setOtherAvatar] = useState("https://nwallet.me/img/avt.jpg");
    const [otherID, setOtherID] = useState(-1);
    const [userName, setUserName] = useState("-----");
    const [otherName, setOtherName] = useState("-----");
    
    const [thread, setThread] = useState(-1);
    const [email, setEmail] = useState("");
    const [repliedMsg, setRepliedMsg] = useState<any>(null);
    const [maxImages, setMaxImages] = useState(0);
    const [totalImages, setTotalImages] = useState(0);
    const [minWords, setMinWords] = useState(0);
    const [totalWords, setTotalWords] = useState(0);
    const [bk, setBK] = useState("");
    const [color, setColor] = useState("");
    const [menu, openMenu] = useState(false);
    const [progress, setProgress] = useState(0.0);

    const contentRef = useRef<VirtuosoHandle | null>(null);
    const inputRef = useRef<HTMLIonTextareaElement | null>(null);
    const [noMoreLoadData, setNoMoreLoadData] = useState(false);
    
    const [canSend, setCanSend] = useState(false);
    const [msg, setMsg] = useState("");
    const [addOption, showAddOption] = useState(false);

    const [formatMsgList, setFormatList] = useState<MsgDataGroup[]>([]);

    const [offline, setOffline] = useState(false);
    const [tag, setTag] = useState("");
    const [curMsg, setCurMsg] = useState<any>({});
    const [ownedMsg, setOwnedMsg] = useState(false);

    const [gif, setGif] = useState(false);
    const [gifData, setGifData] = useState<GifData>({ categories:[], gifs:[], cached_gifs:[] });
    const [likeError, showLikeError] = useState(false);
    const [adReady, setAdReady] = useState(false);
    const [profile, showProfile] = useState(false);
    const [icons, setIcons] = useState<string[]>([]);
    const [names, setNames] = useState<string[]>([]);
    const [replies, setReplies] = useState<string[]>([]);

    const [infoHeader, setInfoHeader] = useState("");
    const [infoDesc, setInfoDesc] = useState("");
    const [avatarIndex, setAvatarIndex] = useState(0);
    const [timerDisplay, setTimerDisplay] = useState("");
    const [status, setStatus] = useState("");
    const [gender, setGender] = useState("boy");
    const [target, setTarget] = useState("both");
    const [totalUsers, setTotalUsers] = useState(2);
    const [firstTime, setFirstTime] = useState(false);
    const [timerDanger, setTimerDanger] = useState(false);
    const [friendAlready, setFriendAlready] = useState(false);
    const [chatState, setChatState] = useState("");
    const [loaderImg, setLoaderImg] = useState("");

    useIonViewWillEnter(() => {
        state = "";
        typed_msg = "";
        timer = 0;
        total_time = 0;
        thread_id = -1;
        // begin the chat session
        InitChatSession();
        
        // refresh in next 5 secs
        refreshTimer = setInterval(() => {
            getData(1);
        }, 5000);

        tickTimer = setInterval(() => {
            doTickTimer();
        }, 1000);
        
        hideTab();
    });

    useIonViewDidEnter(() => {
        scrollToBottom();
    });

    useIonViewWillLeave(() => {
        clearInterval(refreshTimer);
        clearInterval(tickTimer);
        showTab();

        showProfile(false);

        exitCall();
    });

    // for mobile only
    if (window.cordova)
    {
        Keyboard.addListener('keyboardDidShow', info => {
            scrollToBottom();
        });
    }

    // tick the timer
    const doTickTimer = () => {
        if (state == "chat")
        {
            // set the timer
            timer -= 1;
            if (timer < 0)
            {
                timer = 0;
                // skip to next user
                setTimerDisplay("");
                timeUp();
                return;
            }
            
            // show the time left
            if (total_time > 0)
                setProgress(timer / total_time);

            var min = Math.floor(timer / 60);
            var time_display = "";
            if (min < 10)
                time_display = "0" + min;
            else
                time_display = "" + min;
            
            var sec = timer - (min * 60);
            if (sec < 10)
                time_display = time_display + ":0" + sec;
            else
                time_display = time_display + ":" + sec;

            setTimerDisplay("Time: " + time_display);
            if (timer < 30)
                setTimerDanger(true);
            else
                setTimerDanger(false);
        }
    }

    // close the UI
    const closeUI = async () => {
        let result = await showConfirm(GetStr(LANGUAGE.TXT_ASK_EXIT_RCHAT_TITLE), GetStr(LANGUAGE.TXT_ASK_EXIT_RCHAT_DESC));
        if (result.value)
        {
            DoExit();
        }
    }

    // set the chat state
    const setState = (s : string) => {
        state = s;

        // setup each state UI
        if (s == "init")
        {
            setInfoHeader(GetStr(LANGUAGE.TXT_RCHAT_INIT_CAP));
            setInfoDesc(GetStr(LANGUAGE.TXT_RCHAT_INIT_DESC));
            setLoaderImg("/assets/img/rc_icon1.gif")
        }
        if (s == "profile")
        {
            setInfoHeader(GetStr(LANGUAGE.TXT_RCHAT_PROFILE_CAP));
            setInfoDesc(GetStr(LANGUAGE.TXT_RCHAT_PROFILE_DESC));
            setLoaderImg("/assets/img/rc_icon1.gif")
        }
        if (s == "error")
        {
            setFirstTime(false);
            setInfoHeader(GetStr(LANGUAGE.TXT_RCHAT_ERR_CAP));
            setInfoDesc(GetStr(LANGUAGE.TXT_RCHAT_ERR_DESC));

            setLoaderImg("/assets/img/rc_icon_err.gif");
        }
        if (s == "exit")
        {
            setFirstTime(false);
            setInfoHeader(GetStr(LANGUAGE.TXT_RCHAT_EXIT_CAP));
            setInfoDesc(GetStr(LANGUAGE.TXT_RCHAT_EXIT_DESC));

            setLoaderImg("/assets/img/rc_icon6.gif");
        }
        if (s == "search")
        {
            setFirstTime(false);
            setInfoHeader(GetStr(LANGUAGE.TXT_RCHAT_SEARCH_CAP));
            setInfoDesc(GetStr(LANGUAGE.TXT_RCHAT_SEARCH_DESC1) + totalUsers + GetStr(LANGUAGE.TXT_RCHAT_SEARCH_DESC2));

            // random loader
            setLoaderImg("/assets/img/rc_icon" + Math.floor((Math.random() * 6) + 1) + ".gif");
        }
        if (s == "left")
        {
            setFirstTime(false);
            setInfoHeader(GetStr(LANGUAGE.TXT_RCHAT_LEFT_CAP));
            setInfoDesc(GetStr(LANGUAGE.TXT_RCHAT_LEFT_DESC));

            setLoaderImg("/assets/img/rc_icon_skip.gif")
        }
        if (s == "chat")
        {
            setInfoHeader("");
            setInfoDesc("");
        }
    }

    // initialize the chat session
    const InitChatSession = async () => {
        setState("init");
        
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

        var server = new NServer();
        await server.getList("rchat_load", state);

        if (!server.success && server.message != "")
        {
            // error, try again in next 10 seconds
            setState("error");
            setTimeout(()=> { InitChatSession() }, 10000);
        }
        else
        {
            // set data
            setIcons(server.data.icons);
            setNames(server.data.names);
            setReplies(server.data.replies);

            // select user avarar 0
            setAvatarIndex(0)
            setUserAvatar(server.data.icons[0]);
            setUserName(server.data.names[0]);

            // move to next state
            setState("profile");

            showProfile(true);
        }
    }

    // filter unique msg
    const FilterUniqueMsg = (arr : any) : any => {
        let filterList : MsgData[] = [];
        if (arr == null)
            return filterList;

        for (var i = 0; i < arr.length; i++)
        {
            // filter the list
            var same = false;
            for (var j = 0; j < filterList.length; j++)
            {
                if (filterList[j].id == arr[i].id)
                {
                    same = true;
                    break;
                }
            }

            if (!same)
                filterList.push(arr[i]);
        }
        return filterList;
    }

    // update data
    const getData = async (dir : number, scroll : boolean = false) => {
        // load depend on current state
        if (state == "search")
            await searchUser();
        if (state == "chat")
            await loadMsg(dir, scroll);
    }

    // search for new random user to chat
    const searchUser = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

        var server = new NServer();
        await server.sendForm("rchat_find_user", state);

        if (!server.success && server.message != "")
        {
            // error, try again in next 10 seconds
            setState("error");
            setTimeout(()=> { searchUser() }, 10000);
        }
        else
        {
            if (server.data.no_profile == 1)
            {
                // setup profile again
                setState("profile");
                showProfile(true);
                return;
            }

            setTotalUsers(server.data.count);

            if (server.data.match == 1)
            {
                // we found a match
                thread_id = server.data.thread;
                setThread(thread_id);
                setOtherID(server.data.user);
                setOtherName(server.data.name);
                setOtherAvatar(server.data.avatar);
                setFriendAlready(server.data.friends == 1);

                // initialize timer
                timer = server.data.timer;
                total_time = server.data.total_time;

                setState("chat");
                setFirstTime(true);

                // clear the msg
                rawMsgList = [];
                setFormatList([]);
            }
        }
    }

    // search for new random user to chat
    const setupProfile = async () => {
        showProfile(false);

        let v = new Vault();
        await v.read();

        let name = userName;
        if (name == "")
            name = names[avatarIndex];

        const state = {
            id: v.account.id,
            pass: v.account.key,
            profile: avatarIndex,
            name: name,
            gender: gender,
            target: target
        }

        console.log("Setting up profile");

        var server = new NServer();
        await server.sendForm("rchat_set_profile", state);

        if (!server.success && server.message != "")
        {
            // error, try again in next 10 seconds
            setState("error");
            setTimeout(()=> { setupProfile() }, 10000);
        }
        else
        {
            setState("search");
        }
    }

    // load the message when chatting
    const loadMsg = async (dir : number, scroll : boolean) => {
        let v = new Vault();
        await v.read();

        var index = maxIndex;
        if (dir < 0)
            index = minIndex;

        let typing = typed_msg != "";
        
        const state = {
            id: v.account.id,
            pass: v.account.key,
            other : thread_id,
            type : "thread",
            typing: typing ? 1 : 0,
            s : index,
            e : total,
            d : dir
        }

        var server = new NServer();
        await server.getList("rchat_message", state);

        if (!server.success && server.message != "")
        {
            setOffline(true);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            let chat_state = server.data.state;
            // other user left
            if (chat_state == "left")
            {
                setState("left");
                resetUser();
                setTimeout(()=> { setState("search") }, 3000);
                return;
            }

            // update the UI
            setMaxImages(server.data.max_img);
            setTotalImages(server.data.total_img);
            setMinWords(server.data.min_words);
            
            setBK(server.data.bk);
            setColor(server.data.color);

            if (server.data.hasOwnProperty("avatar"))
            {
                setOtherName(server.data.name);
                setOtherAvatar(server.data.avatar);
                setFriendAlready(server.data.friends == 1);
            }

            chat_type = server.data.chat_type;
            setChatState(server.data.state);

            if (server.data.msg.length > 0)
            {
                var msg_list : MsgData[];
                if (dir < 0)
		            msg_list = rawMsgList.concat(server.data.msg);
                else
                    msg_list = server.data.msg.concat(rawMsgList);
                
                // filter duplicates    
                msg_list = FilterUniqueMsg(msg_list);

                var moreData = false;
                if (dir > 0)
                    moreData = true;

                rawMsgList = msg_list;
                buildMsgList(msg_list);

                if (dir > 0 && moreData && scroll)
                {
                    setTimeout(()=> { scrollToBottom() }, 500);
                }
            }
            else
            {
                // if we reach end of data
                if (dir < 0)
                    setNoMoreLoadData(true);
            }

            setOffline(false);
        }

        if (rawMsgList.length < total)
            setNoMoreLoadData(true);
	}

    // build a formatted msg list
    const buildMsgList = async (mlist : MsgData[]) => {
        
        let v = new Vault();
        await v.read();

        const ownerID = v.account.id;

        let formatList : MsgDataGroup[] = [];

        // loop through the array
        var prev : MsgData;
        var next : MsgData;
        var cur : MsgData;
        var curGroup : MsgDataGroup = {} as MsgDataGroup;
        curGroup.sender = -1;
        var msgID : number = 0;
        var showName : boolean = false;

        for (var i = 0; i < mlist.length; i++)
        {
            cur = mlist[i];

            var owner : boolean = false;
            if (ownerID == cur.sender)
                owner = true;
            var format : string = "";
            showName = false;

            // save min and max
            if (maxIndex < cur.id)
                maxIndex = cur.id;
            if (minIndex > cur.id)
                minIndex = cur.id;

            let msg_typef = "msg msg-text";
            if (cur.type == "post")
                msg_typef = "msg msg-post-share";
            if (cur.type == "img")
                msg_typef = "msg-image";

            if (i > 0)
            {
                prev = mlist[i-1];
                if (prev.sender == cur.sender)
                {
                    format = owner ? "m-bottom-right" : "m-bottom-left";
                }
            }

            if (i+1 < mlist.length)
            {
                next = mlist[i+1];
                if (next.sender == cur.sender)
                {
                    if (format != "")
                        format = owner ? "m-right" : "m-left";
                    else
                        format = owner ? "m-top-right" : "m-top-left";
                }

                // show name on last message
                if (next.sender != cur.sender)
                {
                    if (!owner && chat_type == "live")
                        showName = true;
                }
            }

            // for last message
            if (i+1 == mlist.length)
            {
                if (!owner && chat_type == "live")
                    showName = true;
            }

            // add new chat group if not current sender
            if (curGroup.sender != cur.sender)
            {
                
                // add a new message
                curGroup = { 
                             id: msgID++, 
                             messages: [], 
                             sender: cur.sender, 
                             name : cur.name,
	                         avatar : cur.avatar,
	                         owned : owner,
                             last_sent : cur.send_time
                            };
                formatList.push(curGroup);
            }

            // add message
            curGroup.messages.push({
                id : cur.id,
                thread : cur.thread,
                sender : cur.sender,
	            name : cur.name,
	            type : cur.type,
	            avatar : cur.avatar,
	            msg : cur.msg,
	            send_time : cur.send_time,
	            dtime : cur.dtime,
	            format : msg_typef + " " + format,
                showName: showName,
                ref_name : cur.ref_name,
                ref_msg : cur.ref_msg,
                emo : cur.emo,
                extra : cur.extra,
                followed : cur.followed
            });

            curGroup.last_sent = cur.send_time;
        }

        formatList.map( (m) => m.messages.reverse() );
        formatList.reverse();

        setFormatList(formatList);
    }

    const loadMoreData = async () => {
    }  

    const scrollToBottom = () => {
    };

    // update the message
    const updateMsg = (val : string) => {
        if (val != '')
            setCanSend(true);
        else
            setCanSend(false);

        let msg = val.replace(/\s/g, "");
        setTotalWords(msg.length);

        setMsg(val);
        typed_msg = val;
    }

    // add image to message
    const addImg = async () => {
        if (thread < 0)
            return;
        // check for minimum image count
        if (maxImages > 0 && totalImages >= maxImages)
            return;

        const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Uri
        });

        // image.webPath will contain a path that can be set as an image src.
        // You can access the original file using image.path, which can be
        // passed to the Filesystem API to read the raw data of the image,
        // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
        var imageUrl = image.webPath;
        if (imageUrl == undefined)
            return;

        // upload image
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            name: thread,
            type: "mimg"
        }

        var server = new NServer();
        await server.uploadImage(imageUrl, state);

        if (!server.success && server.message != "")
            showAlert(server.message);
    }

    const processSendMsg = (e : any) => {
        if (inputRef.current != null)
        {
            if (e.clientX >= inputRef.current.getBoundingClientRect().right)
            {
                // trigger the button
                sendMsg();
            }
        }
    }

    // send the message
    const sendMsg = async (m : string = "") => {

        let message = msg;
        if (m != "")
            message = m;
        if (message == "")
            return;

        // check for minimum word count
        if (minWords > 0 && totalWords < minWords && m == "")
            return;

        let v = new Vault();
        await v.read();

        let ref = -1;
        if (repliedMsg != null)
            ref = repliedMsg.id;
        setRepliedMsg(null);

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: thread,
            type : "thread",
            msg : message,
            email: email,
            ref: ref
        }

		var server = new NServer();
        await server.sendForm("nc_send_msg", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // refresh UI
            await getData(1);

            setCanSend(false);
            if (inputRef.current != null)
                inputRef.current.value = "";
        }

        // no more first time messaging
        setFirstTime(false);
    }

    // send the message
    const deleteMsg = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: 10,
            type : "thread"
        }

		var server = new NServer();
        await server.sendForm("del_msg", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            router.push("/messages", "back", "pop");
            window.location.reload();
        }
    }

    // show the gif
    const showGif = () => {
        if (maxImages > 0 && totalImages >= maxImages)
            return;

        setGif(true);
        loadGif(0);
    }

    // send gif
    const processSendGif = async (gif : string) => {
        setGif(false);
        showAddOption(false);

        if (gif == "")
            return;
        // check for minimum image count
        if (maxImages > 0 && totalImages >= maxImages)
            return;

        let ref = -1;
        if (repliedMsg != null)
            ref = repliedMsg.id;
        setRepliedMsg(null);

        // upload image
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: thread,
            type : "thread",
            msg : gif,
            email: email,
            ref: ref
        }

		var server = new NServer();
        await server.sendForm("nc_send_msg_gif", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // refresh UI
            await getData(1);

            setCanSend(false);
            if (inputRef.current != null)
                inputRef.current.value = "";
        }
    }

    // load the gif
    const loadGif = async (cat : number) => {
        // clear first
        setGifData({ categories: gifData.categories, gifs:[], cached_gifs:[] });

        // load
        let gifs : GifData = await LoadGifs(cat);
        setGifData(gifs);
    }

    // click on a message
    const onClickMsg = async (m : MsgData) => {
        setCurMsg(m);
        openMenu(true);
    }

    // reply to message
    const replyMsg = () => {
        setRepliedMsg(curMsg);
    }

    // delete the message
    const deleteCurMsg = async () => {
        curMsg.type = "del";

        // find the message
        for (let i = 0; i < rawMsgList.length; i++)
        {
            if (rawMsgList[i].id == curMsg.id)
                rawMsgList[i].type = "del";
        }
        
        // refresh local
        buildMsgList(rawMsgList);

        // actually delete the message
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            msg_id : curMsg.id
        }

		var server = new NServer();
        await server.sendForm("del_one_msg", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
    }

    // emoticon was reacted
    const onEmoticon = async (msg : MsgData, index : number) => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            mid : msg.id,
            type: index
        }

		var server = new NServer();
        await server.sendForm("msg_emo", state);

        if (!server.success && server.message != "")
        {
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        
        // refresh msg
        rawMsgList = [];
        maxIndex = -1;
        minIndex = Number.MAX_VALUE;

        getData(1, false);
    }

    // watch an Ads
    const watchAds = () => {
        setAdReady(false);
        showLikeError(false);
        
        // show the ads
        ShowAds( () => {
            
        });
    }

    // send a like
    const sendLikes = async (msgid : number, likes : number) => {
        // send like to server
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: msgid,
            likes: likes,
            ano: 0
        }

		var server = new NServer();
        await server.sendForm("nc_msg_like", state);

        if (server.data.nolike == 1)
        {
            let ready = await ReadyAds();
            setAdReady(ready);
            showLikeError(true);
            return;
        }

        if (!server.success && server.message != "")
        {
            showAlert(server.message);
        }
        else
        {
            if (server.data.has_token == "no")
            {
                showAlert(GetStr(LANGUAGE.TXT_NO_NTOKEN_LIKE));
            }

            // refresh msg
            rawMsgList = [];
            maxIndex = -1;
            minIndex = Number.MAX_VALUE;

            getData(1, false);
        }
    }

    // exit the chat
    const DoExit = async () => {
        setState("exit");

        await exitCall();

        // exit whether succeed or not
        router.push("/main", "back", "pop");
    }

    // call to exit 
    const exitCall = async () => {
        // alert server user is exiting
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.sendForm("rchat_exit", state);
    }

    // select the avatar index
    const selectAvatarIndex = (index : number) => {

        let defName = names[avatarIndex];

        // set this index
        setAvatarIndex(index);
        setUserAvatar(icons[index]);

        if (userName == "" || userName == defName)
            setUserName(names[index]);
    }

    // send the auto reply
    const sendAutoReply = (msg : string) => {
        sendMsg(msg);
        setFirstTime(false);
    }

    // time up
    const timeUp = () => {
        skipUser();
    }

    // skip to next user
    const skipUser = async () => {
        // alert server user is exiting
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.sendForm("rchat_skip", state);

        // move to search
        setState("search");

        resetUser();
    }

    // reset user
    const resetUser = () => {
        // clear message
        rawMsgList = [];
        setFormatList([]);

        setFirstTime(false);
        setChatState("");
        setThread(-1);
        thread_id = -1;
        
        setProgress(0);        
        setOtherID(-1);
        setOtherName("-----");
        setTimerDisplay("");
        setOtherAvatar("https://nwallet.me/img/avt.jpg");
    }

    // friend request reply
    const friendRequestReply = async (re : string) => {
        setChatState("");

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            reply: re
        }

		var server = new NServer();
        await server.sendForm("rchat_req_friend_reply", state);

        setChatState("");
    }

    // friend reqest to user
    const friendRequest = async () => {
        setFriendAlready(true);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.sendForm("rchat_req_friend", state);
    }

    return (
       <IonPage>
            <IonHeader translucent>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton onClick={closeUI}><IonIcon icon={arrowBackOutline} /></IonButton>
                    </IonButtons>
                    <IonItem lines="none">
                        <IonAvatar slot="start">
                            <img src={otherAvatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                        </IonAvatar>
                        <IonLabel>
                            <div><small>{ status }</small></div>
                            { otherName }
                        </IonLabel>
                        <IonLabel slot="end" color={ timerDanger ? "danger" : "primary" }><b>{ timerDisplay }</b></IonLabel>
                    </IonItem>
                </IonToolbar>
                <IonProgressBar value={progress}></IonProgressBar>
                {
                    // friend request
                    chatState == "freq" ?
                <IonToolbar>
                    <IonLabel className="ion-padding-start" slot="start" color="primary">{ GetStr(LANGUAGE.TXT_RCHAT_FRIEND_REQ) }</IonLabel>
                    <IonButtons slot="end">
                        <IonButton fill="clear" color="success" onClick={ ()=> friendRequestReply("yes") } >
                            <IonIcon slot="start" icon={checkmark}></IonIcon>
                        </IonButton>
                        <IonButton fill="clear" color="danger" onClick={ ()=> friendRequestReply("no") }>
                            <IonIcon slot="start" icon={close}></IonIcon>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                    :
                <div/>
                }
                {
                    offline ?
                <div className="ion-text-center"><IonText color="medium"><small>{ GetStr(LANGUAGE.TXT_OFFLINE) }</small></IonText></div>
                    :
                <div />
                }
            </IonHeader>
            <IonContent id="msg-content" scrollY={false} >
                {
                    infoHeader != "" ?
                <IonGrid className="ion-no-padding full-screen wrapper">
                    <IonRow className="flex-center">
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="6" size-lg="4" size-xl="4" size="10">
                            <IonCard className="round-card">
                                <IonCardHeader>
                                    <IonCardTitle className="ion-text-center">{ infoHeader }</IonCardTitle>
                                </IonCardHeader>
                                <IonCardContent className="ion-text-center">
                                    <div className="spinnerCenter ion-margin-bottom">
                                    {
                                        loaderImg != "" ?
                                        <img className="ion-padding" src={loaderImg} />
                                        :
                                        <IonSpinner name="crescent" />
                                    }
                                    </div>
                                    { infoDesc }
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                    :
                <div className="chat-container ion-no-padding full-screen">
                    <div className="full-screen">
                    {                
                        formatMsgList.length > 0 ? 
                        <Virtuoso id="chat-view" className="ion-content-scroll-host"
                            ref={contentRef}
                            data={formatMsgList}
                            initialTopMostItemIndex={9999}
                            totalCount={formatMsgList.length}
                            followOutput="auto"
                            itemContent={(index, m) => 
                                <ChatMsgGroup key={index} group={m} action={ onClickMsg } emo={ onEmoticon } like={ sendLikes } ctype="rchat" />
                            }
                        >
                        </Virtuoso>
                        :
                        <div/>
                    }
                </div>
            </div>
            }
            </IonContent>
            <IonFooter>
                {
                    firstTime ?
                <div className="replies-content">
                    <div className="button-bar">
                        <small>Say Hello - </small>
                        {
                            replies.map( (m, index) => 
                            <IonChip onClick={ ()=> sendAutoReply(m) } key={index}>{ m }</IonChip>
                            )
                        }
                    </div>
                </div>
                    :
                <div/>
                }
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton fill="clear" color="primary" disabled={ otherID < 20 || friendAlready } onClick={friendRequest} >
                            <IonIcon slot="start" icon={personAdd}></IonIcon>
                            { GetStr(LANGUAGE.TXT_RCHAT_FRIEND_BUT) }
                        </IonButton>
                        <IonButton fill="clear" color="primary" disabled={ otherID < 20 } onClick={skipUser}>
                            <IonIcon slot="start" icon={playSkipForward}></IonIcon>
                            { GetStr(LANGUAGE.TXT_RCHAT_SKIP_BUT) }
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                
                { /* reply message */ }
                {
                    repliedMsg != null ?
                <div>
                    <IonToolbar className="reply-bar">
                        <IonLabel color="primary"><small><b>{ GetStr(LANGUAGE.TXT_CMT_REPLYING_TO) }</b></small></IonLabel>
                        <IonButton slot="end" fill="clear" onClick={ () => setRepliedMsg(null) }>
                            <IonIcon icon={closeOutline} />
                        </IonButton>
                    </IonToolbar>
                    <div className="reply-box">
                        <IonText color="medium">
                            <b>{ repliedMsg.name }</b>
                            <div className="reply-comment">{ repliedMsg.msg }</div>
                        </IonText>
                    </div>
                </div>
                    :
                <div/>
                }
                {/* bottom message input */}
                <div className="wrapper">
                    {
                        /* image options */
                        addOption && gif ?
                    <GifContent content={gifData} onSend={processSendGif} onHide={ ()=>setGif(false) } onChange={loadGif}></GifContent>
                        :
                        addOption ?
                    <IonToolbar>
                        <IonButtons>
                            { /* DEL
                            <IonButton color="primary" onClick={addImg} disabled={thread<0}>
                                <IonIcon icon={imageOutline}></IonIcon>&nbsp;
                                { GetStr(LANGUAGE.TXT_CHAT_UPLOAD_IMG) }
                            </IonButton>
                            */ }
                            <IonButton color="primary" onClick={showGif} disabled={thread<0}>
                                <IonIcon icon={imagesOutline}></IonIcon>&nbsp;
                                { GetStr(LANGUAGE.TXT_CHAT_SEND_GIF) }
                            </IonButton>
                        </IonButtons>
                        {
                            maxImages > 0 ?
                        <IonLabel className="ion-margin-end" slot="end">{totalImages} / {maxImages}</IonLabel>
                            :
                        <div/>
                        }
                    </IonToolbar>
                        :
                    <div/>
                    }
                    {
                        /* minimum words limit */
                        minWords > 0 ?
                    <div>
                        <IonText color="medium">
                            <small className="ion-float-right ion-margin-end">{ GetStr(LANGUAGE.CHAT_MSG_MIN_WORDS) + totalWords + " / " + minWords }</small>
                        </IonText>
                    </div>
                        :
                    <div/>
                    }
                    <div className="message">
                        
                        {
                            addOption ?
                        <IonButton className="action" color="primary" fill="clear" onClick={()=> showAddOption(false)}>
                            <IonIcon icon={closeOutline}></IonIcon>
                        </IonButton>  
                            :
                        <IonButton className="action" color="primary" fill="clear" onClick={()=> showAddOption(true)}>
                            <IonIcon icon={addOutline}></IonIcon>
                        </IonButton>  
                        }
                        <IonItem className="msg-box" onClick={e => processSendMsg(e) } lines="none">
                            <IonTextarea className="msg-textarea" id="input-msg" ref={inputRef} rows={1} auto-grow maxlength={500} placeholder={ GetStr(LANGUAGE.TXT_CHAT_TYPE) } onIonChange={e => updateMsg(e.detail.value!)} disabled={thread<0}></IonTextarea>
                            <IonIcon className="icon-but" slot="end" color={ (minWords > 0 && totalWords < minWords) ? "medium" : "primary" } icon={sendOutline}></IonIcon>
                        </IonItem>
                    </div>
                </div>
            </IonFooter>
            
            { /* menu */ }
            <IonActionSheet
                isOpen={menu}
                onDidDismiss={() => openMenu(false)}
                buttons={
                    [
                    {
                        text: GetStr(LANGUAGE.TXT_MSG_REPLY_CUR),
                        icon: arrowRedoOutline,
                        handler: replyMsg
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_MSG_DEL_CUR),
                        icon: trashOutline,
                        handler: deleteCurMsg
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_CANCEL),
                        icon: close,
                        role: 'cancel',
                        handler: () => { openMenu(false) }
                    } 
                    ]
                }
                >
            </IonActionSheet>

            { /* user settings */ }
            <IonModal
                isOpen={profile}
                initialBreakpoint={ 0.9 }
                backdropDismiss={false}
                onDidDismiss={ () => showProfile(false) }>
                <div className="ion-page">
                    <IonToolbar id="modal">
                        <IonItem lines="none">
                            <IonIcon slot="start" icon={person} />
                            <IonLabel>{ GetStr(LANGUAGE.TXT_RCHAT_PROFILE_TITLE) }</IonLabel>
                        </IonItem>
                    </IonToolbar>
                    <IonContent>
                        <IonGrid className="rchat-profile-view">
                            <IonRow className="ui-row">
                                <IonCol size="4">
                                    { GetStr(LANGUAGE.TXT_RCHAT_SET_NAME) }
                                </IonCol>
                                <IonCol size="8">
                                    <IonInput className="text-input" value={ userName } maxlength={20} onIonChange={ (e)=> { setUserName(e.detail.value!) } }></IonInput>
                                </IonCol>
                            </IonRow>
                            <IonRow className="ui-row">
                                <IonCol>
                                    { GetStr(LANGUAGE.TXT_RCHAT_SET_AVT) }
                                </IonCol>
                            </IonRow>
                            <IonRow className="ui-row">
                                <IonCol>
                                    <div className="avt-select-wrapper">
                                    {
                                        icons.map( (s, index) =>
                                            <div key={index} className="avt-select-parent ion-activatable ripple-parent" onClick={()=> selectAvatarIndex(index) }>
                                                <IonAvatar className="avt-select" ><img src={s} /></IonAvatar>
                                                {
                                                    avatarIndex == index ?
                                                <img className="avt-select-tick" src="/assets/img/bm.png" />
                                                    :
                                                <div/>
                                                }
                                                <IonRippleEffect></IonRippleEffect>
                                            </div>
                                        )
                                    }
                                    </div>
                                </IonCol>
                            </IonRow>
                            <IonRow className="ui-row">
                                <IonCol>
                                    { GetStr(LANGUAGE.TXT_RCHAT_SET_GENDER) }
                                </IonCol>
                            </IonRow>
                            <IonRow className="ui-row">
                                <IonCol>
                                    <IonSegment value={ gender } mode="ios" onIonChange={ (e) => setGender(e.detail.value!) } >
                                        <IonSegmentButton value="boy">
                                            <IonLabel>{ GetStr(LANGUAGE.TXT_RCHAT_BOY) }</IonLabel>
                                        </IonSegmentButton>
                                        <IonSegmentButton value="girl">
                                            <IonLabel>{ GetStr(LANGUAGE.TXT_RCHAT_GIRL) }</IonLabel>
                                        </IonSegmentButton>
                                    </IonSegment>
                                </IonCol>
                            </IonRow>
                            <IonRow className="ui-row">
                                <IonCol>
                                    { GetStr(LANGUAGE.TXT_RCHAT_SET_LOOKFOR) }
                                </IonCol>
                            </IonRow>
                            <IonRow className="ui-row">
                                <IonCol >
                                    <IonSegment value={ target } mode="ios" onIonChange={ (e) => setTarget(e.detail.value!) }>
                                        <IonSegmentButton value="boy">
                                            <IonLabel>{ GetStr(LANGUAGE.TXT_RCHAT_BOY) }</IonLabel>
                                        </IonSegmentButton>
                                        <IonSegmentButton value="girl">
                                            <IonLabel>{ GetStr(LANGUAGE.TXT_RCHAT_GIRL) }</IonLabel>
                                        </IonSegmentButton>
                                        <IonSegmentButton value="both">
                                            <IonLabel>{ GetStr(LANGUAGE.TXT_RCHAT_BOTH) }</IonLabel>
                                        </IonSegmentButton>
                                    </IonSegment>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonButton className="main-but" expand="block" color="secondary" onClick={ ()=> { showProfile(false); DoExit(); }}>
                                        { GetStr(LANGUAGE.TXT_RCHAT_EXIT) }
                                    </IonButton>
                                </IonCol>
                                <IonCol>
                                    <IonButton className="main-but" expand="block" onClick={ setupProfile }>
                                        { GetStr(LANGUAGE.TXT_RCHAT_OK) }
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonContent>
                </div>
            </IonModal>

            { /* like error dialogbox */ }
            <LikeErrComp  isOpen={ likeError } onDidDismiss={ () => showLikeError(false) } adReady={ adReady } watchAds={ watchAds }  />

        </IonPage>
    );
};

export default RandomChat;